import 'date-input-polyfill-react'
import moment from 'moment'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import React, { useState } from 'react'
// import { useFetchList } from 'store'
import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'

import styles from './Dialog.module.sass'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'
import Datepicker, { DATE_FORMAT } from 'components/Datepicker/Datepicker'
import { translateErrorMessage } from 'hooks/useSubmitTask'

const options = [
	{
		value: 104,
		text: 'Gestão Administrativa',
	},
	{
		value: 120,
		text: 'Gestão Clínica',
	},
	{
		value: 126,
		text: 'Suporte',
	},
	{
		value: 119,
		text: 'Serviços Clínico',
	},
]

const NotificationDialog = (props) => {
	const { className, data, resolve, dismiss } = props
	const { i18n, expireSession, pushNotification } = useGlobal()
	const [message, setMessage] = useState('')
	const [date, setDate] = useState(moment())
	const [notificationType, setNotificationType] = useState(options[0].value)
	const [submitting, setSubmitting] = useState(false)
	const [error, setError] = useState(null)

	// const {
	// 	contents: [options = []],
	// } = useFetchList(
	// 	['/metadata/notification_types'],
	// 	[
	// 		(json) => {
	// 			return { value: `${json.id}`, text: i18n.translate(json.name) }
	// 		},
	// 	]
	// )

	// useEffect(() => {
	// 	if (options && options.length && !notificationType) {
	// 		setNotificationType(() => {
	// 			return options[0].value
	// 		})
	// 	}
	// }, [options, notificationType])

	const handleSubmit = (e) => {
		e.preventDefault()
		const url = `${API_URL}/api/clinical_processes/${data?.processId}/notifications`
		setError(null)
		setSubmitting(true)
		fetch(
			url,
			fetchOptions({
				method: 'POST',
				body: { type: notificationType, comment: message, date: date },
			})
		)
			.then((r) => parseJSONContent(r))
			.then(() => {
				resolve && resolve()
				pushNotification(
					undefined,
					'success',
					i18n`Notification inserted successfully!`
				)
			})
			.catch((err) => {
				if (err.status === '401' || err.status === 401) {
					expireSession()
				}
				const errorMessage = translateErrorMessage(err, i18n)

				setSubmitting(false)
				setError([errorMessage])
			})
	}

	return (
		<>
			<TaskHeaderErrors errors={error ?? []} />
			<form
				id={'form_notification'}
				className={`${styles['root'] || ''} ${className || ''}`}
				onSubmit={handleSubmit}
			>
				<fieldset>
					<h5 className={styles['dialog-title']}>
						{i18n`Enter you message`}
					</h5>
					<TextInput
						placeholder={i18n`Message`}
						value={message}
						required
						multiline
						noResize
						rows='3'
						onChange={(e) => {
							setMessage(e.target.value)
						}}
					/>
					<Datepicker
						initialDate={moment(moment(), DATE_FORMAT, true)}
						type='date'
						text={i18n`Date`}
						onChange={(date) => {
							setDate(date)
						}}
					/>
					<Dropdown
						placeholder={i18n`Notification Type`}
						layout='horizontal'
						options={options || []}
						value={notificationType}
						optionsAlign='right'
						onChange={(e) => {
							setNotificationType(e.target.value)
						}}
					/>
				</fieldset>
			</form>
			<menu>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`Cancel`}</strong>
					</small>
				</ActionButton>
				<ActionButton form={'form_notification'} primary>
					<small>
						<strong>
							{submitting ? i18n`Submitting` : i18n`Send`}
						</strong>
					</small>
				</ActionButton>
			</menu>
		</>
	)
}

export default NotificationDialog
